
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34200',
  depVersions: {
  "documents-public-ui": "static-1.34200",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34205",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2012",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.101",
  "hs-promise-utils": "static-1.5479",
  "hs-test-utils": "static-1.7896",
  "hub-http": "static-1.6103",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2-me-set-font-family-mixin.4",
  "I18n": "static-7.1598",
  "jasmine-immutable": "static-1.2902",
  "jasmine-runner": "static-1.6354",
  "lodash": "static-1.3",
  "quartz": "static-1.6846",
  "react": "static-7.183",
  "react-dlb": "static-1.75",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16538",
  "reporting-data": "static-1.66939",
  "reporting-testing-lib": "static-1.8872",
  "reporting-visualizations": "static-1.59015",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4653",
  "webpack-env": "static-1.54",
  "atom": "static-1.4954",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2378",
  "classnames": "static-2.10",
  "cssUtils": "static-1.764",
  "customer-data-filters-ui": "static-1.39261",
  "customer-data-objects": "static-1.7538",
  "customer-data-property-utils": "static-1.7966",
  "data-fetching-client": "static-1.9560",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4413",
  "flux-actions": "static-1.323",
  "FormsCommonComponents": "static-1.85528",
  "FormUrlGenerator": "static-2.4604",
  "foundations-components": "static-1.7689",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2-me-set-font-family-mixin.4",
  "icons": "static-2-me-set-font-family-mixin.2",
  "immutable": "static-2.76",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7044",
  "metrics-js": "static-1.9522",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3739",
  "property-translator": "static-1.5294",
  "quartz-config": "static-1.624",
  "quartz-core": "static-1.6065",
  "quick-fetch": "static-1.3818",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5252",
  "react-virtualized": "static-2.96",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8050",
  "reference-resolvers-lite": "static-1.7973",
  "report-customization-components": "static-1.12787",
  "reporting-enablement": "static-1.22430",
  "reporting-reports": "static-1.66617",
  "reporting-snowflake": "static-1.55557",
  "reporting-ui-components": "static-2.64210",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4527",
  "sales-content-partitioning": "static-1.8821",
  "SalesContentIndexUI": "static-3.9056",
  "sanitize": "static-1.4357",
  "sanitize-text": "static-1.8029",
  "self-service-api": "static-1.10129",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1636",
  "signup-constants": "static-1.18621",
  "signup-ui-lego-core": "static-1.20631",
  "signup-ui-url-generator": "static-2.7923",
  "styled-components": "static-2.87",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4653",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10876",
  "ui-addon-i18n": "static-1.11031",
  "ui-addon-react-router-dom": "static-1.9429",
  "ui-addon-upgrades": "static-9.17807",
  "ui-asset-management-lib": "static-1.10852",
  "ui-images": "static-2-me-set-font-family-mixin.2",
  "UIComponents": "static-3-me-set-font-family-mixin.4",
  "usage-tracker": "static-1.7220",
  "usage-tracker-container": "static-1.7210",
  "usage-tracker-core": "static-1.7070",
  "usage-tracker-public": "static-1.7031",
  "viral-links-lib": "static-1.6921",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3309",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3123",
  "quartz-webpack": "static-1.3070",
  "ai-components-ui-library": "static-1.8630",
  "amplitude-session-replay-browser": "static-1.57",
  "foundations-assets": "static-1.4728",
  "foundations-theming": "static-1.4296",
  "quartz-auth": "static-1.521",
  "ui-business-units-lib": "static-1.8923",
  "usage-tracker-session-replay": "static-1.4906",
  "foundations-theming-base": "static-1.3281",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.3007",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4209",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7808",
  "graphql": "static-1.79",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3494",
  "persist-promise": "static-1.3593",
  "reporting-client-types": "static-1.2425",
  "foundations-components-legacy": "static-1.714",
  "hs-story-utils": "static-1.9313",
  "react-flip-move": "static-1.67",
  "hub-http-shared-msw-handlers": "static-1.9694",
  "hubspotter-http": "static-1.4556",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7133",
  "crm-message-bus": "static-1.42643",
  "customer-data-filters-ui-msw-helpers": "static-1.21696",
  "customer-data-objects-ui-components": "static-1.12901",
  "customer-data-reference-ui-components": "static-1.13036",
  "customer-data-ui-utilities": "static-1.9709",
  "framework-builder-read-service-client": "static-1.3913",
  "framework-data-schema-quick-fetch": "static-1.6664",
  "framework-data-schema-resolvers": "static-1.6759",
  "inbound-db-properties-service-client": "static-1.3750",
  "multi-account-reference-resolvers": "static-1.867",
  "onboarding-tours": "static-1.16388",
  "reporting-datasets-permissions-lib": "static-1.13332",
  "ui-addon-teams": "static-1.21383",
  "apollo-stack-hubspot": "static-3.83",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67956",
  "customer-data-properties": "static-1.51112",
  "forms-ai-lib": "static-1.4137",
  "forms-utils-lib": "static-1.12358",
  "foundations-components-test-utils": "static-1.5172",
  "react-dnd-compat": "static-1.4503",
  "react-tinymce": "static-1.54894",
  "tinymce-config": "static-2.54020",
  "ui-gdpr-components": "static-1.10232",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3958",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1476",
  "ui-fonts": "static-1-me-set-font-family-mixin.4",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-head": "static-1.511",
  "quartz-i18n": "static-1.521",
  "quartz-routing": "static-1.276",
  "quartz-test": "static-1.521",
  "quartz-tracking": "static-1.225",
  "batch-promise": "static-1.1436",
  "external-options-client-types": "static-1.4063",
  "react-colorpicker": "static-2.10094",
  "copilot-toolkit": "static-1.10792",
  "data-quality-ui-library": "static-1.12552",
  "html-to-image": "static-1.51",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6347",
  "reporting-action-components": "static-1.40921",
  "reporting-insights-lib": "static-1.1354",
  "reporting-plugins": "static-1.10110",
  "ui-addon-draggable-compat": "static-2.4138",
  "ui-addon-opt": "static-4.8267",
  "ui-shepherd-react": "static-3.10031",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25003",
  "hubspot-apollo-client": "static-1.4763",
  "chirp-fetch": "static-1.1766",
  "sales-templates-service-types-lib": "static-1.4071",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5650",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3983",
  "timezone-utils": "static-2.5128",
  "bender-build-tools": "static-1.3041",
  "chatspot-core": "static-1.20750",
  "bend-plugin-foundations-theming": "static-1.2779",
  "stylex": "static-1.29",
  "hubspotter-http-shared-msw-handlers": "static-1.9692",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3702",
  "crm-pipelines-api-client-types": "static-1.4047",
  "multi-currency-client-types": "static-1.3594",
  "getting-started-shared-tasks": "static-1.18153",
  "growth-data-modal": "static-1.5249",
  "growth-onboarding-confetti": "static-1.2956",
  "growth-onboarding-next-action-utils": "static-1.1561",
  "navigation-components": "static-1.17595",
  "onboarding-tours-client": "static-1.4602",
  "onboarding-tours-utils": "static-1.454",
  "ui-shepherd-tracker": "static-1.7412",
  "ui-universal-auth": "static-1.8812",
  "user-context": "static-1.4984",
  "cms-field-types": "static-1.4693",
  "content-icons-ui": "static-1.2191",
  "integrations-lib": "static-1.15719",
  "calling-global-api": "static-1.64035",
  "calling-internal-common": "static-1.31186",
  "calling-lifecycle-internal": "static-1.65417",
  "calling-lifecycle-messages": "static-1.57711",
  "commerce-products-lib": "static-1.9109",
  "crm-links": "static-1.6158",
  "file-manager-components": "static-1.23237",
  "google-libphonenumber": "static-1.35",
  "hs-resources": "static-1.18",
  "inbounddb-objects-service-types": "static-1.4127",
  "meetings-icalendar-utils-lib": "static-1.515",
  "object-builder-ui-client": "static-1.48335",
  "pipeline-validation-client-types": "static-1.3868",
  "property-value-citations": "static-1.1726",
  "pulse": "static-1.417",
  "smart-property-lib": "static-1.6363",
  "tiered-pricing": "static-1.984",
  "ui-addon-iframeable": "static-1.8934",
  "final-form": "static-1.67",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19630",
  "tinymce-themes": "static-1.55990",
  "data-token-picker": "static-1.16201",
  "hub-http-contrib": "static-1.2927",
  "interframe": "static-3.4647",
  "tinymce-data": "static-1.40105",
  "tinymce-plugins": "static-1.57134",
  "ui-addon-sales-email": "static-1.5096",
  "magpie-lib": "static-1.5478",
  "magpie-types": "static-1.4938",
  "simple-logging-lib": "static-1.2935",
  "content-assistance-lib": "static-1.7577",
  "dashboard-lib": "static-1.81017",
  "ExportDialog": "static-6.10273",
  "hubspot-prosemirror": "static-1.17886",
  "hubspot-prosemirror-plugins": "static-1.17878",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8577",
  "campaign-roi-lib": "static-1.8576",
  "feedback-loader": "static-1.29070",
  "apollo-link-hub-http": "static-2.4535",
  "hubspot-apollo-cache": "static-1.222",
  "growth-monetization-service-types": "static-1.4383",
  "nav-client-types": "static-1.2241",
  "purchase-motions-api": "static-1.5653",
  "trials-service-types": "static-1.3784",
  "onboarding-data-sync-lib": "static-1.1765",
  "growth-onboarding-next-action-components": "static-1.1589",
  "user-context-client": "static-1.4496",
  "idb-keyval": "static-1.41",
  "nest": "static-1.106",
  "reactive-lib": "static-1.608",
  "unified-auth-core-lib": "static-1.607",
  "getting-started-shared-tasks-store": "static-1.17271",
  "integrations-error-boundary-lib": "static-1.13134",
  "integrations-tracking-lib": "static-1.5479",
  "native-integrations-shared-strings": "static-1.7671",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10258",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.326",
  "calling-error-reporting": "static-1.31192",
  "shared-worker-versioning": "static-1.10923",
  "calling-usage-tracker": "static-1.6426",
  "voice-sms-access-library": "static-1.537",
  "customer-data-tracking": "static-1.6767",
  "commerce-permissions": "static-1.649",
  "products-iframe-lib": "static-1.7593",
  "products-ui-components-shared-msw-handlers": "static-1.10076",
  "location-customization-utils-lib": "static-1.8859",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4037",
  "video-components-external": "static-1.10882",
  "video-data-lib": "static-1.34540",
  "directed-graph": "static-1.822",
  "event-emitter": "static-1.832",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5451",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9777",
  "fsm": "static-1.3618",
  "policy-lib": "static-1.6667",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9840",
  "navigation-messaging": "static-1.6922",
  "FileManagerLib": "static-1.38877",
  "NamespacedHubStyle": "static-2.8973",
  "FileManagerCore": "static-1.38736",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12219",
  "layout-dnd-utils": "static-1.11194",
  "react-codemirror": "static-1.10508",
  "ui-addon-emoji-picker": "static-1.9771",
  "ui-brand-identity-lib": "static-1.14655",
  "ui-addon-video-player": "static-1.8580",
  "ui-coaching-tips": "static-1.28200",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23191",
  "EmailSignatureEditor": "static-1.24105",
  "eligibility-engine-service-types": "static-1.3065",
  "InboxConnectUtils": "static-4.14477",
  "universal-page-editor-lib": "static-1.2890",
  "calling-orchestration-schema": "static-1.35314",
  "sales-views-client-types": "static-1.4147",
  "crm-record-cards-service-types": "static-1.3515",
  "content-media-composition-data-lib": "static-1.11838",
  "content-media-compositions": "static-2.15845",
  "media-bridge-lib": "static-1.18721",
  "trellis-story-utils": "static-1.4404",
  "storybook-react": "static-1.30",
  "audio-components": "static-1.5740",
  "FileManagerImages": "static-1.36388",
  "video-components": "static-1.12885",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4416",
  "video-embed": "static-1.35374",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68031",
  "layout-data-lib": "static-1.9519",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6465",
  "commerce-tours-lib": "static-1.5879",
  "growth-onboarding-reliability": "static-1.4971",
  "sales-checkout-service-client": "static-1.3552",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21469",
  "sales-email-signature-service-client": "static-1.3727",
  "social-insights-client-types": "static-1.21712",
  "outpost": "static-1.4081",
  "advanced-menus-core": "static-1.14947",
  "advanced-menus-lib": "static-1.11912",
  "ui-memberships-settings-lib": "static-1.33709",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14946",
  "simple-menus-lib": "static-1.16463"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34200",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34205",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2012",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.101",
  "hs-promise-utils": "/hs-promise-utils/static-1.5479",
  "hs-test-utils": "/hs-test-utils/static-1.7896",
  "hub-http": "/hub-http/static-1.6103",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2-me-set-font-family-mixin.4",
  "I18n": "/I18n/static-7.1598",
  "jasmine-immutable": "/jasmine-immutable/static-1.2902",
  "jasmine-runner": "/jasmine-runner/static-1.6354",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6846",
  "react": "/react/static-7.183",
  "react-dlb": "/react-dlb/static-1.75",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16538",
  "reporting-data": "/reporting-data/static-1.66939",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8872",
  "reporting-visualizations": "/reporting-visualizations/static-1.59015",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4653",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4954",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2378",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39261",
  "customer-data-objects": "/customer-data-objects/static-1.7538",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7966",
  "data-fetching-client": "/data-fetching-client/static-1.9560",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4413",
  "flux-actions": "/flux-actions/static-1.323",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85528",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4604",
  "foundations-components": "/foundations-components/static-1.7689",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2-me-set-font-family-mixin.4",
  "icons": "/icons/static-2-me-set-font-family-mixin.2",
  "immutable": "/immutable/static-2.76",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7044",
  "metrics-js": "/metrics-js/static-1.9522",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3739",
  "property-translator": "/property-translator/static-1.5294",
  "quartz-config": "/quartz-config/static-1.624",
  "quartz-core": "/quartz-core/static-1.6065",
  "quick-fetch": "/quick-fetch/static-1.3818",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5252",
  "react-virtualized": "/react-virtualized/static-2.96",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8050",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7973",
  "report-customization-components": "/report-customization-components/static-1.12787",
  "reporting-enablement": "/reporting-enablement/static-1.22430",
  "reporting-reports": "/reporting-reports/static-1.66617",
  "reporting-snowflake": "/reporting-snowflake/static-1.55557",
  "reporting-ui-components": "/reporting-ui-components/static-2.64210",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4527",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8821",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9056",
  "sanitize": "/sanitize/static-1.4357",
  "sanitize-text": "/sanitize-text/static-1.8029",
  "self-service-api": "/self-service-api/static-1.10129",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1636",
  "signup-constants": "/signup-constants/static-1.18621",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20631",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7923",
  "styled-components": "/styled-components/static-2.87",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4653",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10876",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11031",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9429",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17807",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10852",
  "ui-images": "/ui-images/static-2-me-set-font-family-mixin.2",
  "UIComponents": "/UIComponents/static-3-me-set-font-family-mixin.4",
  "usage-tracker": "/usage-tracker/static-1.7220",
  "usage-tracker-container": "/usage-tracker-container/static-1.7210",
  "usage-tracker-core": "/usage-tracker-core/static-1.7070",
  "usage-tracker-public": "/usage-tracker-public/static-1.7031",
  "viral-links-lib": "/viral-links-lib/static-1.6921",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3309",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3123",
  "quartz-webpack": "/quartz-webpack/static-1.3070",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8630",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4728",
  "foundations-theming": "/foundations-theming/static-1.4296",
  "quartz-auth": "/quartz-auth/static-1.521",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8923",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4906",
  "foundations-theming-base": "/foundations-theming-base/static-1.3281",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3007",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4209",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7808",
  "graphql": "/graphql/static-1.79",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3494",
  "persist-promise": "/persist-promise/static-1.3593",
  "reporting-client-types": "/reporting-client-types/static-1.2425",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.714",
  "hs-story-utils": "/hs-story-utils/static-1.9313",
  "react-flip-move": "/react-flip-move/static-1.67",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9694",
  "hubspotter-http": "/hubspotter-http/static-1.4556",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7133",
  "crm-message-bus": "/crm-message-bus/static-1.42643",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21696",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12901",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13036",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9709",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3913",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6664",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6759",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3750",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.867",
  "onboarding-tours": "/onboarding-tours/static-1.16388",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13332",
  "ui-addon-teams": "/ui-addon-teams/static-1.21383",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67956",
  "customer-data-properties": "/customer-data-properties/static-1.51112",
  "forms-ai-lib": "/forms-ai-lib/static-1.4137",
  "forms-utils-lib": "/forms-utils-lib/static-1.12358",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5172",
  "react-dnd-compat": "/react-dnd-compat/static-1.4503",
  "react-tinymce": "/react-tinymce/static-1.54894",
  "tinymce-config": "/tinymce-config/static-2.54020",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10232",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3958",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1476",
  "ui-fonts": "/ui-fonts/static-1-me-set-font-family-mixin.4",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-head": "/quartz-head/static-1.511",
  "quartz-i18n": "/quartz-i18n/static-1.521",
  "quartz-routing": "/quartz-routing/static-1.276",
  "quartz-test": "/quartz-test/static-1.521",
  "quartz-tracking": "/quartz-tracking/static-1.225",
  "batch-promise": "/batch-promise/static-1.1436",
  "external-options-client-types": "/external-options-client-types/static-1.4063",
  "react-colorpicker": "/react-colorpicker/static-2.10094",
  "copilot-toolkit": "/copilot-toolkit/static-1.10792",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12552",
  "html-to-image": "/html-to-image/static-1.51",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6347",
  "reporting-action-components": "/reporting-action-components/static-1.40921",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1354",
  "reporting-plugins": "/reporting-plugins/static-1.10110",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4138",
  "ui-addon-opt": "/ui-addon-opt/static-4.8267",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10031",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25003",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4763",
  "chirp-fetch": "/chirp-fetch/static-1.1766",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4071",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5650",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3983",
  "timezone-utils": "/timezone-utils/static-2.5128",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "chatspot-core": "/chatspot-core/static-1.20750",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2779",
  "stylex": "/stylex/static-1.29",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9692",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3702",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4047",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3594",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18153",
  "growth-data-modal": "/growth-data-modal/static-1.5249",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2956",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1561",
  "navigation-components": "/navigation-components/static-1.17595",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4602",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.454",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7412",
  "ui-universal-auth": "/ui-universal-auth/static-1.8812",
  "user-context": "/user-context/static-1.4984",
  "cms-field-types": "/cms-field-types/static-1.4693",
  "content-icons-ui": "/content-icons-ui/static-1.2191",
  "integrations-lib": "/integrations-lib/static-1.15719",
  "calling-global-api": "/calling-global-api/static-1.64035",
  "calling-internal-common": "/calling-internal-common/static-1.31186",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65417",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57711",
  "commerce-products-lib": "/commerce-products-lib/static-1.9109",
  "crm-links": "/crm-links/static-1.6158",
  "file-manager-components": "/file-manager-components/static-1.23237",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-resources": "/hs-resources/static-1.18",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4127",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.515",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48335",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3868",
  "property-value-citations": "/property-value-citations/static-1.1726",
  "pulse": "/pulse/static-1.417",
  "smart-property-lib": "/smart-property-lib/static-1.6363",
  "tiered-pricing": "/tiered-pricing/static-1.984",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8934",
  "final-form": "/final-form/static-1.67",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19630",
  "tinymce-themes": "/tinymce-themes/static-1.55990",
  "data-token-picker": "/data-token-picker/static-1.16201",
  "hub-http-contrib": "/hub-http-contrib/static-1.2927",
  "interframe": "/interframe/static-3.4647",
  "tinymce-data": "/tinymce-data/static-1.40105",
  "tinymce-plugins": "/tinymce-plugins/static-1.57134",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5096",
  "magpie-lib": "/magpie-lib/static-1.5478",
  "magpie-types": "/magpie-types/static-1.4938",
  "simple-logging-lib": "/simple-logging-lib/static-1.2935",
  "content-assistance-lib": "/content-assistance-lib/static-1.7577",
  "dashboard-lib": "/dashboard-lib/static-1.81017",
  "ExportDialog": "/ExportDialog/static-6.10273",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17886",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17878",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8577",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8576",
  "feedback-loader": "/feedback-loader/static-1.29070",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4535",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.222",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4383",
  "nav-client-types": "/nav-client-types/static-1.2241",
  "purchase-motions-api": "/purchase-motions-api/static-1.5653",
  "trials-service-types": "/trials-service-types/static-1.3784",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1765",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1589",
  "user-context-client": "/user-context-client/static-1.4496",
  "idb-keyval": "/idb-keyval/static-1.41",
  "nest": "/nest/static-1.106",
  "reactive-lib": "/reactive-lib/static-1.608",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.607",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17271",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13134",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5479",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7671",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10258",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.326",
  "calling-error-reporting": "/calling-error-reporting/static-1.31192",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10923",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6426",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.537",
  "customer-data-tracking": "/customer-data-tracking/static-1.6767",
  "commerce-permissions": "/commerce-permissions/static-1.649",
  "products-iframe-lib": "/products-iframe-lib/static-1.7593",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10076",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8859",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4037",
  "video-components-external": "/video-components-external/static-1.10882",
  "video-data-lib": "/video-data-lib/static-1.34540",
  "directed-graph": "/directed-graph/static-1.822",
  "event-emitter": "/event-emitter/static-1.832",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5451",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9777",
  "fsm": "/fsm/static-1.3618",
  "policy-lib": "/policy-lib/static-1.6667",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9840",
  "navigation-messaging": "/navigation-messaging/static-1.6922",
  "FileManagerLib": "/FileManagerLib/static-1.38877",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8973",
  "FileManagerCore": "/FileManagerCore/static-1.38736",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12219",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11194",
  "react-codemirror": "/react-codemirror/static-1.10508",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9771",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14655",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8580",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28200",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23191",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24105",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3065",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14477",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2890",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35314",
  "sales-views-client-types": "/sales-views-client-types/static-1.4147",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3515",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11838",
  "content-media-compositions": "/content-media-compositions/static-2.15845",
  "media-bridge-lib": "/media-bridge-lib/static-1.18721",
  "trellis-story-utils": "/trellis-story-utils/static-1.4404",
  "storybook-react": "/storybook-react/static-1.30",
  "audio-components": "/audio-components/static-1.5740",
  "FileManagerImages": "/FileManagerImages/static-1.36388",
  "video-components": "/video-components/static-1.12885",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4416",
  "video-embed": "/video-embed/static-1.35374",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68031",
  "layout-data-lib": "/layout-data-lib/static-1.9519",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6465",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5879",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4971",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3552",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21469",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3727",
  "social-insights-client-types": "/social-insights-client-types/static-1.21712",
  "outpost": "/outpost/static-1.4081",
  "advanced-menus-core": "/advanced-menus-core/static-1.14947",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11912",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33709",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14946",
  "simple-menus-lib": "/simple-menus-lib/static-1.16463"
}
};
